import React, { useEffect, useState } from "react";
import axiosInstance from '../api/axiosInstance'
import './../assets/css/RightMenuPanel.css'

// home 우측 패널
const RightMenuPanel = ({ onSelect, searchValue }) => {
    const [groupedData, setGroupedData] = useState({});
  
    useEffect(() => {
      if (!searchValue || searchValue.length === 0) {
        setGroupedData({}); // 빈 데이터로 초기화 추가
        return;
      }
        // 검색 결과 있을 경우 → 검색된 데이터로 구성
        const grouped = searchValue.reduce((acc, item) => {
          const key = item.artcl_CD || item.ARTCL_CD;
          if (!acc[key]) acc[key] = [];
          acc[key].push(item);
          return acc;
        }, {});
        
        setGroupedData(grouped);
        return;
    }, [searchValue]);
    
    const allAttributes = Object.values(groupedData).flat();

    // 중복 없는 컴포넌트만 추출
    const uniqueComponents = Array.from(
        new Map(allAttributes.map((item) => [item.ARTCL_NM, item])).values()
    );
    
    // ARTCL_CD 기준으로 정렬
    uniqueComponents.sort((a, b) => {
      return a.ARTCL_CD.localeCompare(b.ARTCL_CD);
  });

  const handleScrollToSection = (item) => {
    const sectionId = item.ARTCL_NM || item.artcl_NM;
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  if (!searchValue || searchValue.length === 0) {
    return null;
  }

  return (
    <div className="right-menu-panel">
      <ul className="menu-list">
        {uniqueComponents.map((item, index) => (
          <li key={index} className="menu-item">
            <a
              href={`#${item.ARTCL_NM}`}
              className="menu-link"
              onClick={(e) => {
                e.preventDefault();
                onSelect?.(item);
                handleScrollToSection(item);
              }}
            >
              {item.ARTCL_NM}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RightMenuPanel;
